import { render, staticRenderFns } from "./muban.vue?vue&type=template&id=f041b640&scoped=true&"
import script from "./muban.vue?vue&type=script&lang=js&"
export * from "./muban.vue?vue&type=script&lang=js&"
import style0 from "./muban.vue?vue&type=style&index=0&id=f041b640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f041b640",
  null
  
)

export default component.exports